'use strict';

import { Notifications } from './Notifications.js';

/**
 * Toast API for consistent notifications across the app.
 * Use Toast.success() / Toast.error() or window.levToast.success() / window.levToast.error()
 */
export const Toast = {
	success(message, options = {}) {
		new Notifications()
			.setType('success')
			.setMessage(message)
			.setTimeout(options.timeout ?? 2000)
			.setPosition(options.position ?? 'right_top')
			.execPopup(options.additionalClasses ?? []);
	},
	error(message, options = {}) {
		new Notifications()
			.setType('error')
			.setMessage(message)
			.setTimeout(options.timeout ?? 4000)
			.setPosition(options.position ?? 'right_top')
			.execPopup(options.additionalClasses ?? []);
	},
};
